
export const APIURI = 'https://auth-app.fnvt.net';
export const APIKEY = 'ceaa05c7-e01f-434f-b350-ea6f90731221';